import {IAppService} from "@/services/IAppService";

/**
 * Только для legacy X-Auth-Token
 * @deprecated
 */
declare let apiAuthToken: string;

export class AppService implements IAppService {
    readonly version: string;
    readonly changelog: string;
    readonly apiDomain: string;
    readonly legacyDomain: string;
    readonly legacyApiDomain: string;
    readonly apiLegacyAuthToken: string;
    readonly mercuryDomain: string;
    readonly domain: string;
    private readonly _env: string;

    constructor() {
        this._env = process.env.NODE_ENV as string;

        this.version = process.env.VUE_APP_VERSION || "";
        this.changelog = process.env.VUE_APP_CHANGELOG || "";

        if (window.location.hostname === "localhost" || window.location.hostname.includes("astrovolga.st")) {
            this.domain = ".astrovolga.st";

            this.apiDomain = `https://b2b${this.domain}/api`;
            this.legacyDomain = `https://polis${this.domain}`;
            this.legacyApiDomain = `https://api${this.domain}`;
            this.mercuryDomain = `https://push${this.domain}/.well-known/mercure`;
        } else {
            this.domain = "";
            /*
               this.apiDomain = process.env.API_DOMAIN_URL || `https://polis${this.domain}`;
               this.legacyDomain = process.env.LEGACY_B2B_DOMAIN_URL || `https://polis${this.domain}`;
               this.legacyApiDomain = process.env.LEGACY_API_DOMAIN_URL || `https://api${this.domain}`;
               this.mercuryDomain = process.env.MERCURY_DOMAIN_URL || `https://push${this.domain}/.well-known/mercure`;
           */

            this.apiDomain = "/apiDomain";
            this.legacyDomain = "/legacyDomain";
            this.legacyApiDomain = "/legacyApiDomain";
            this.mercuryDomain = "/mercuryDomain";
        }

        try {
            this.apiLegacyAuthToken = apiAuthToken;
        } catch (e) {
            this.apiLegacyAuthToken = "";
        }
    }

    get isDevMode(): boolean {
        return this._env === "development";
    }

    get isTestMode(): boolean {
        return this._env === "test";
    }
}
